
<div class="w-100">
    <d-service-partner
        v-model = "showComanyEdit"
        :company-name = "searchInput"
        :roles  = "[ { id: 11, name: 'Ausf. Unternehmen',  label: 'AU', value: false } ]"
        @stored = "onCreated"
    />

    <v-autocomplete
        v-model           = "selected"
        :items            = "items"
        :rules            = "rules"
        :hint             = "hint"
        :label            = "label"
        :readonly         = "readonly"
        :disabled         = "readonly"
        :clearable        = "true"
        color             = "primary"
        item.id           = "id"
        item-text         = "name"
        @change           = "onChange"
        :return-object    = "true"
        :background-color = background
        :search-input.sync="searchInput"
        cache-items
        auto-select-first
        persistent-hint
    >
        <template v-slot:append-outer>
            <div v-if="!selected">
                <c-toolbar-button
                    color   = "primary"
                    icon    = "mdi-plus"
                    size    = "22"
                    tooltip = "Neues Ausführendes Unternehmen anlegen"
                    @click  = "onCompany"
                />
            </div>
        </template>
        <template v-slot:no-data>
            <div class="ml-2 mr-2" style="font-size: 15px">
                Das Unternehmen wurde nicht gefunden. Mit + kann ein neues Unternehmen angelegt werden.
            </div>
        </template>
    </v-autocomplete>
</div>
